import React from 'react';

import { ProjectIssueTypesContext } from '@qality/common-components/src/lib/ProjectIssueTypesProvider';
import {
  QAlityOptions,
  getQAlityFields,
} from '@qality/common-components/src/molecules/ImportTestCasesForm';
import WizardForm from '@qality/common-components/src/molecules/final-form/WizardForm';

import { ImportTestCasesFormPageContainerStyled } from './ImportTestCasesForm.styled';
import { FieldMapper, fieldMapperValidator } from './steps/FieldMapper';
import { Import } from './steps/Import';
import {
  UploadFiles,
  uploadFilesSubmit,
  uploadFilesValidator,
} from './steps/UploadFiles';

export const ImportTestCasesFormView = ({ initialValues }: any) => {
  const { projectIssueTypes } = React.useContext(ProjectIssueTypesContext);

  const requiredQAlityFieldNames = QAlityOptions.filter((f) => f.required);
  const requiredJiraFieldNames = getQAlityFields(projectIssueTypes).filter(
    (f) => f.required
  );

  const fieldMapperValidatorWithFields = fieldMapperValidator([
    ...requiredQAlityFieldNames,
    ...requiredJiraFieldNames,
  ]);

  return (
    <ImportTestCasesFormPageContainerStyled>
      <WizardForm
        header='Import Test Cases from CSV file'
        initialValues={initialValues}
      >
        <WizardForm.Page
          label='Files set up'
          validate={uploadFilesValidator}
          onSubmit={uploadFilesSubmit}
        >
          <UploadFiles />
        </WizardForm.Page>
        <WizardForm.Page
          label='Map fields'
          nextWording='Start Import'
          validate={fieldMapperValidatorWithFields}
        >
          <FieldMapper />
        </WizardForm.Page>
        <WizardForm.Page label='Import' showNavigation={false}>
          <Import />
        </WizardForm.Page>
      </WizardForm>
    </ImportTestCasesFormPageContainerStyled>
  );
};
